import { cx } from "class-variance-authority";
import styles from "./PlayerCard.module.css";

interface PlayerCardProps {
  className: string;
  children: React.ReactNode;
  id: string;
}

export function PlayerCard({ children, className, id }: PlayerCardProps) {
  return (
    <div className={cx(styles.playerCard, className)} id={id}>
      {children}
    </div>
  );
}
